const config = {
  gatsby: {
    pathPrefix: '/',
    siteUrl: 'https://zevi.ai',
    gaTrackingId: null,
    trailingSlash: false,
  },
  header: {
    logo: '',
    logoLink: 'https://zevi.ai',
    title: 'Zevi AI',
    githubUrl: '/',
    helpUrl: '',
    tweetText: '',
    social: ``,
    links: [{ text: '', link: '' }],
    search: {
      enabled: false,
      indexName: '',
      algoliaAppId: process.env.GATSBY_ALGOLIA_APP_ID,
      algoliaSearchKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY,
    },
  },
  sidebar: {
    forcedNavOrder: [
      '/',
      '/getting-started',
      '/data-ingestion-crud',
      '/authentication',
      '/search',
      '/chat',
      '/auto-complete',
      '/analytics',
      // add trailing slash if enabled above
      // '/codeblock',
    ],
    collapsedNav: [
      '/codeblock', // add trailing slash if enabled above
    ],
    links: [{ text: 'Zevi.ai', link: 'https://zevi.ai' }],
    frontLine: false,
    ignoreIndex: false,
    title: 'Zevi.ai',
  },
  siteMetadata: {
    title: 'Zevi.ai',
    description:
      "Zevi's AI-powered site search and discovery platform helps customers discover products quickly, boosting sales & conversions.",
    ogImage: null,
    docsLocation: '',
    favicon: '',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'Zevi AI',
      short_name: 'Zevi AI',
      start_url: '/',
      background_color: '#6b37bf',
      theme_color: '#6b37bf',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/zevi-logo-glass-nobg.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
